import { createSlice } from '@reduxjs/toolkit';
import { fetchConversationsAction, toggleAdminConversationsAction } from './conversationThunk';

const initialState = {
  conversations: {},
  isLoading: false,
  error: null,
};

const conversationSlice = createSlice({
  name: 'conversations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConversationsAction.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchConversationsAction.fulfilled, (state, action) => {
        const { chatId, data } = action.payload;
        state.conversations[chatId] = data || [];
        state.isLoading = false;
      })
      .addCase(fetchConversationsAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(toggleAdminConversationsAction.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(toggleAdminConversationsAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isAdminEnabled = !state.isAdminEnabled; 
      })
      .addCase(toggleAdminConversationsAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default conversationSlice.reducer;
